/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `refund` - Refund
 * * `credit` - Credit
 */
export enum RefundDestinationEnum {
  REFUND = 'refund',
  CREDIT = 'credit',
}
